import { PropsWithChildren } from 'react';
import cx from 'classnames';
import { CatCard } from '@blocks-react/components/Card';
import { CatIconChevronRight } from '@blocks-react/components/Icons/ChevronRight';
import { CatIconArrowForward } from '@blocks-react/components/Icons/ArrowForward';
import { CatHeading } from '@blocks-react/components/Heading';
import styles from './FooterButton.module.scss';
import { CatIconSearch } from '@blocks-react/components/Icons/Search';
import { CatIconHelp } from '@blocks-react/components/Icons/Help';
import { CatIconPerson } from 'blocks-nextjs/blocks-react/components/Icons/Person';
import { CatIconPeople } from 'blocks-nextjs/blocks-react/components/Icons/People';
import { CatIconLanguage } from 'blocks-nextjs/blocks-react/components/Icons/Language';
import { CatIconGrid } from 'blocks-nextjs/blocks-react/components/Icons/Grid';
type FooterButtonProps = {
  title: string;
  icon: string;
  onClick: () => void;
};
enum iconType {
  SEARCH = 'CatIconSearch',
  HELP = 'CatIconHelp',
  PERSON = 'CatIconPerson',
  PEOPLE = 'CatIconPeople',
  LANGUAGE = 'CatIconLanguage',
  GRID = 'CatIconGrid'
}
export const FooterButton = ({
  title,
  icon,
  children,
  onClick
}: PropsWithChildren<FooterButtonProps>) => {
  const iconSize = 'lg';
  const iconColor = 'knockout-brand';
  const getIcon = () => {
    switch (icon) {
      case iconType.SEARCH:
        return <CatIconSearch color={iconColor} size={iconSize} />;
      case iconType.HELP:
        return <CatIconHelp color={iconColor} size={iconSize} />;
      case iconType.PERSON:
        return <CatIconPerson color={iconColor} size={iconSize} />;
      case iconType.PEOPLE:
        return <CatIconPeople color={iconColor} size={iconSize} />;
      case iconType.LANGUAGE:
        return <CatIconLanguage color={iconColor} size={iconSize} />;
      case iconType.GRID:
        return <CatIconGrid color={iconColor} size={iconSize} />;
      default:
        return <CatIconSearch color={iconColor} size={iconSize} />;
    }
  };

  return (
    <>
      <CatCard
        data-testId="footer-button-mobile"
        className={cx(styles['footer_Button'])}
        onClick={onClick}
      >
        <div className="d-flex gap-3 align-items-center align-items-md-start py-lg-2">
          {getIcon()}
          <div className="d-flex flex-md-column flex-grow-1 flex-lg-grow-0 justify-content-between align-items-center gap-1 ">
            {/* title and icon */}
            <div className="d-flex w-100 justify-content-between gap-2 align-items-center align-items-md-start">
              <CatHeading
                level="h3"
                variant="title-sm"
                color="knockout"
                className="text-center d-block"
              >
                {title}
              </CatHeading>
              <div className="d-block d-lg-none">
                <CatIconChevronRight color="knockout-brand" />
              </div>
              <div
                className={cx(
                  'd-none d-lg-block position-absolute',
                  styles['arrow_upward']
                )}
              >
                <CatIconArrowForward />
              </div>
            </div>
          </div>
        </div>
      </CatCard>
      <ul className={styles['footer__list']}>{children}</ul>
    </>
  );
};
